var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 40,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3662a2",
    d: "M-2.2 0v28.8L42.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38a100",
    d: "M55.5 40V10L10.1 40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c70000",
    d: "M-2.2 31v9h9.9L55.4 8V0h-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "m18.3 14.3-1.8-1-1 1.8-1-1.9-2 1.1.1-2.1h-2l1-1.8-1.8-1 1.8-1-1-2 2 .1v-2l1.9 1 1-1.8 1 1.8 1.9-1v2h2l-1 1.9 1.8 1-1.9 1 1.1 1.9h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3662a2",
    d: "M19.4 9.4a4 4 0 0 1-4 3.8 3.9 3.9 0 1 1 0-7.7 4 4 0 0 1 4 3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "M18.5 9.4a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.43e9e0aa433f4f796b3bd39720cc6d6b.svg";
export { ForwardRef as ReactComponent };